module.exports = "/_next/static/images/chavaty_top-955c3b5b10b8ddc03fd28b3fe43d75b7.jpg";